import { render } from "./DMSCatalogue.vue?vue&type=template&id=92b1de44&scoped=true"
import script from "./DMSCatalogue.vue?vue&type=script&lang=js"
export * from "./DMSCatalogue.vue?vue&type=script&lang=js"

import "./DMSCatalogue.vue?vue&type=style&index=0&id=92b1de44&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92b1de44"]])

export default __exports__